import * as React from 'react';
import { withDependencies } from '@symbiotic/green-state';
import { AccountService } from '../support/AccountService';

interface LogoutProps {
  accountService?: AccountService; // injected
}

@withDependencies({ accountService: AccountService })
export class Logout extends React.Component<LogoutProps> {
  async componentDidMount() {
    await this.props.accountService!.logout();
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/portal-react-app/Logout.tsx